import { useEffect, useState, type FC } from 'react';

import {
  Button,
  Typography,
  Icon,
  toast,
  Toastify,
  useDeviceType,
} from 'pixel-react';
import { useNavigate } from 'react-router-dom';

import { useReSendActivationMutation } from '@/store/resetActivationLink/resetActivationLinkSlice';
import type { SuccessState } from '@/types/expiredActivation';
import type { SignUpResponse } from '@/types/signUp';

import styles from './WarningActivation.module.scss';
import { SignUpWrapper } from '../SignUpWrapper';

export const WarningActivation: FC = () => {
  const clientName = import.meta.env.VITE_CLIENT_DETAIL?.name;
  const navigate = useNavigate();
  const { isMobile } = useDeviceType();
  const [email, setEmail] = useState<string | null>('');

  const [createUpdateCalled, setCreateUpdateCalled] = useState(true);
  const [showActiveUserText, setActiveUserText] = useState<SuccessState>({
    open: false,
    message: '',
  });
  let search = window.location.search;
  // Fix the URL if there are multiple '?'
  if (search.indexOf('?') !== search.lastIndexOf('?')) {
    const parts = search.split('?');
    search = '?' + parts.slice(1).join('&');
  }
  useEffect(() => {
    const emailId = new URLSearchParams(search).get('email');
    setEmail(emailId);
  }, []);

  function verifyIsUserActive(response: SignUpResponse) {
    //TODO: User is already activated this should check from a key from respoce
    if (
      response.responseCode === 400 &&
      response.message === 'User is already activated'
    ) {
      setActiveUserText({ open: true, message: response.message });
      toast.success(response.message);
    } else if (response.responseObject) {
      setTimeout(() => {
        setCreateUpdateCalled(true);
        toast.success(response.message);
      }, 10000);
    }
  }
  const [resendActivationLink] = useReSendActivationMutation();
  const handleResendLink = async () => {
    if (createUpdateCalled) {
      try {
        const payLoad = { emailId: email };
        const response = (await resendActivationLink(
          payLoad,
        ).unwrap()) as SignUpResponse;
        if (response?.responseObject) {
          verifyIsUserActive(response);
          toast.success(response?.message);
        } else {
          toast.info(response?.message);
        }
      } catch (error) {
        console.error('Login failed. Please check your credentials.', error);
      }
    }
  };

  return (
    <SignUpWrapper
      content_header={
        <>
          {' '}
          <Typography fontSize="24px" fontWeight="bold">
            The all-in-one <br /> Integrated Testing <br /> Platform
          </Typography>{' '}
        </>
      }
      sub_content={`Revolutionize your workflow with ${clientName}, seamlessly integrating third-party tools and offering versatile cross-platform testing.`}
      footer_content={`${clientName}: High Speed Testing, Simplified!`}
      copyright_content={`Copyright © ${clientName} Pvt Ltd. All Rights Reserved`}
      className={styles.warning_active_container}
    >
      <section className={styles.form_container}>
        <aside className={styles.warning_active_form}>
          <section className={styles['icon_container']}>
            <Icon
              color=""
              height={isMobile ? 160 : 240}
              width={isMobile ? 160 : 240}
              name="user_warning"
            />
          </section>
          <section className={styles.warning_active_header}>
            <Typography
              fontSize="32px"
              textAlign="center"
              className={styles['header_text']}
            >
              Warning Activation
            </Typography>
            {showActiveUserText.open ? (
              <Typography
                fontSize="16px"
                textAlign="center"
                lineHeight="22px"
                className={styles['sub_header_text']}
              >
                Your {clientName} account is active, Please visit login page to
                get started with {clientName}.
              </Typography>
            ) : (
              <Typography
                fontSize="16px"
                textAlign="center"
                lineHeight="22px"
                className={styles['sub_header_text']}
              >
                Your account is not yet activated. Click on the activation link
                which has been sent to your registered email ID
              </Typography>
            )}
          </section>

          <div className={styles.exp_activationlink_footerbtn}>
            {showActiveUserText.open ? (
              <div className={styles.footerBtn_container}>
                <div className={styles.backward_footerbtn}>
                  <Button
                    type="button"
                    variant="secondary"
                    onClick={() => {
                      navigate('/signin');
                    }}
                    buttonWidth="177px"
                  >
                    <Typography
                      fontSize="16px"
                      className={styles['register_btn']}
                    >
                      Back to Sign In
                    </Typography>
                  </Button>
                </div>
              </div>
            ) : (
              <div className={styles.footerBtn_container}>
                <div className={styles.backward_footerbtn}>
                  <Button
                    type="button"
                    variant="secondary"
                    onClick={() => {
                      navigate('/signin');
                    }}
                    buttonWidth="245px"
                  >
                    <Typography
                      fontSize="16px"
                      className={styles['register_btn']}
                    >
                      Back to Sign In
                    </Typography>
                  </Button>
                </div>
                <div className={styles.exp_activationlink_footerbtn}>
                  <Button
                    type="submit"
                    variant="primary"
                    onClick={handleResendLink}
                    buttonWidth="245px"
                  >
                    <Typography
                      fontSize="16px"
                      className={styles['register_btn']}
                    >
                      Resend Activation Link
                    </Typography>
                  </Button>
                </div>
              </div>
            )}
          </div>
        </aside>
      </section>
      <Toastify />
    </SignUpWrapper>
  );
};
